module.exports = __webpack_public_path__ + "static/media/banner3.75f986c0.png";